
import Vue from 'vue';
import Component from 'vue-class-component';
import { Client, IOrderLine, InvoiceViewModel,AcceptPendingOrderArgs,RejectPendingOrderArgs,RequestModifyPendingOrderArgs } from 'Api/CoreApi';
import { InvoiceDetailsComponent } from "Components/CustomerCenter/InvoiceDetails/InvoiceDetailsComponent";
import { Prop } from 'vue-property-decorator';
import ApiProvider from 'Api/ApiProvider';
@Component({})
export default class PendingOrderDetailsComponent extends InvoiceDetailsComponent {
    @Prop()
    redirectUrl: string;

    comment: string = "";

    acceptPendingOrder() {
        let emails = this.invoice.invoice.billingAddress.extraInfo["OrderEmails"];

        // If there is any accounting mails, they need to be added as well
        if (this.invoice.invoice.billingAddress.extraInfo["AccountingEmails"] != "") {
            emails = this.invoice.invoice.shippingAddress.extraInfo["OrderEmails"]
                    + ';' + this.invoice.invoice.billingAddress.extraInfo["AccountingEmails"]
        }

        let client = ApiProvider.getApiClient();
        const args = new AcceptPendingOrderArgs({
            linkId: this.linkId,
            orderId: this.invoice.invoice.orderId,
            email: emails
        });
        client.acceptPendingOrder(args).then(() => {
            location.href = this.redirectUrl;
        }).catch(e => this.setError(e));
    }
    rejectPendingOrder() {
        let client = ApiProvider.getApiClient();
        const args = new RejectPendingOrderArgs({
            linkId: this.linkId,
            orderId: this.invoice.invoice.orderId,
            email: this.invoice.invoice.shippingAddress.extraInfo["OrderEmails"]
        });
        client.rejectPendingOrder(args).then(() => {
            location.href = this.redirectUrl;
        }).catch(e => this.setError(e));
    }
    requestModificationPendingOrder() {
        const client = ApiProvider.getApiClient();

        const args = new RequestModifyPendingOrderArgs({
            linkId: this.linkId,
            orderId: this.invoice.invoice.orderId,
            email: this.invoice.invoice.shippingAddress.extraInfo["OrderEmails"],
            comment: this.comment
        });
        client.requestModifyPendingOrder(args).then(() => {
            location.href = this.redirectUrl;
        }).catch(e => this.setError(e));
    }
}

Vue.component("order-pending-details", PendingOrderDetailsComponent);